import { useTranslation } from '@gem/modules/i18n';

import { phoneNumberCheckValidation, usernameValidation } from '../fields/fields';
import type { IFormFieldValidation, IValidateParams, ValidationResult } from '../hooks';
import { useAsyncValidation, useSyncValidation } from '../hooks';
import { ValidationErrorType } from '../validation.types';

export interface IPhoneNumberAsyncDeps {
  phoneNumberAsyncValidation: (params: IValidateParams) => Promise<string | null>;
}

export interface IContactValidations {
  userName: IFormFieldValidation;
  phoneNumber: IFormFieldValidation;
}

export const useSharedContactValidations = (deps: IPhoneNumberAsyncDeps): IContactValidations => {
  const { t } = useTranslation();

  const usernameErrorToText = {
    [ValidationErrorType.Empty]: ' ',
    [ValidationErrorType.TooShort]: t('username_min_length_error'),
  };

  const phoneNumberErrorToText = {
    [ValidationErrorType.PhoneInvalid]: t('invalid_phone_number'),
  };

  const usernameValidator = useSyncValidation();
  const phoneNumberValidator = useAsyncValidation();

  return {
    userName: {
      validate: (value, _formData, meta): ValidationResult => {
        return usernameValidator({
          value,
          meta: meta!,
          validate: usernameValidation,
          errorToText: usernameErrorToText,
        });
      },
    },
    phoneNumber: {
      validate: (value, _formData, meta, data): ValidationResult => {
        return phoneNumberValidator({
          value,
          meta: meta!,
          validate: phoneNumberCheckValidation,
          asyncValidate: deps.phoneNumberAsyncValidation,
          errorToText: phoneNumberErrorToText,
          data,
        });
      },
    },
  };
};
